import styled, { css } from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";
import * as Type from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import * as Button from "../../../../../../../common-deprecated/styles/v2/lexus/components/Button";

export const DetailsWrapper = styled.div`
    &::before {
        position: absolute;
        left: 0;
        right: 0;
        content: "";
        background-color: ${theme.colors.white};
    }
`;

export const Title = styled.div<{ collapsible?: true } & SpaceProps>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: ${theme.space[3] / 2}px;
    padding-bottom: ${theme.space[2]}px;
    font-family: ${theme.fonts.regular};
    font-size: 1.4rem;
    letter-spacing: 1%;
    line-height: 2.2rem;
    text-transform: uppercase;
    color: ${theme.colors.midnight};
    ${space}

    @media ${getBreakpoint("up", "md")} {
        font-size: 1.8rem;
        letter-spacing: 1%;
        line-height: 2.4rem;
    }

    ${({ collapsible }) =>
        collapsible &&
        css`
            cursor: pointer;
        `};

    ${Type.Strong} {
        display: block;
        font-family: ${theme.fonts.regular};
        font-size: 1.4rem;
        text-transform: uppercase;
        color: ${theme.colors.midnight};
    }

    ${Button.Link} {
        display: flex;
        align-items: center;
        font-size: 1.8rem;
        text-transform: none;
        /* Temporty fix: alignment for svg icon (can be removed when the refresh-icon is added to icon font) */
        svg {
            position: relative;
            top: -1px;
        }
    }

    ${Button.EllipsisText} {
        display: none;
        @media ${getBreakpoint("up", "md")} {
            display: block;
        }
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: ${theme.space[3] / 2}px;
    margin: ${theme.space[3]}px 0;
    padding: ${theme.space[2]}px 0;
    border-bottom: 1px solid ${theme.colors.silver};

    @media ${getBreakpoint("up", "md")} {
        flex-direction: row;
        row-gap: 0;
        justify-content: space-between;
    }

    ${Title} {
        display: flex;
        align-items: center;
        margin-bottom: 0;
        padding-bottom: 0;
        @media ${getBreakpoint("up", "md")} {
            max-width: 50%;
        }
    }
`;

export const Row = styled.div<{ align?: "start" | "end"; iconPosition?: "left" | "right" }>`
    display: flex;
    align-items: center;
    justify-items: end;
    justify-content: ${({ align }) => (align ? `flex-${align}` : "space-between")};
    padding: 6px 0;
    font-family: ${theme.fonts.book};
    font-size: 1.8rem;
    color: ${theme.colors.platinumDark};
    white-space: pre-wrap;
    ${Button.Link} {
        font-size: 1.6rem;
        line-height: 2.4rem;
    }
    .icon {
        flex-shrink: 0;
        ${({ iconPosition }) =>
            iconPosition &&
            css`
                    margin-${iconPosition === "left" ? "right" : "left"}: ${theme.space[1]}px;
                `};
    }
`;

export const PriceCol = styled.div`
    padding: 0 ${theme.spacer / 2}px;
`;

export const Panel = styled.div<{ visible?: boolean }>`
    display: ${({ visible }) => (visible ? "block" : "none")};
`;

export const Divider = styled.div`
    width: 100%;
    height: 1px;
    border-bottom: 1px solid ${theme.colors.silver};
`;
